module.exports = "/_next/static/files/13de74f0affdaef2dfaae5ec218ebc99.svg";